import React, { FunctionComponent } from 'react';
import { logoutBackofficeUser } from 'features/backoffice/backofficeSlice';
import { useAppDispatch } from 'app/hooks';
import { useNavigate } from 'react-router-dom';
import { navigateTop } from 'common/utils/index';

const Home: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const logout = () => {
    dispatch(logoutBackofficeUser());
    navigate('/');
    navigateTop();
  };
  return <div></div>;
};

export default Home;
